// Carrier operating-zone map (read-only) on the manager carrier page.
// 2GIS mapgl port of the former Google Maps drawing. Polygons come from the
// hidden .polygon-input fields as PG polygon literals "((lat,lng),...)".
window.MapDrawing = {

  map: undefined,
  polygons: [],

  twoGisKey: function () {
    return document.documentElement.dataset.gisKey || '';
  },

  createMap: function (center, zoom) {
    var mapgl = window.mapgl;
    var div = document.getElementById('gMapDraw');
    if (!mapgl || !div) return;

    // center is {lat, lng}; mapgl uses [lng, lat]
    this.map = new mapgl.Map(div, {
      center: [center.lng, center.lat],
      zoom: zoom,
      key: this.twoGisKey(),
      zoomControl: 'topRight',
    });
    this.polygons = [];
  },

  getInputsPolygons: function (classInput) {
    return $('.' + classInput);
  },

  parseInputValueToArray: function (string) {
    return JSON.parse(string.replace(/\(/g, '[').replace(/\)/g, ']'));
  },

  // points: [[lat,lng],...] or [{lat,lng},...] -> mapgl [[lng,lat],...]
  polygonPointsToPaths: function (points) {
    if (typeof points === 'string') {
      points = MapDrawing.parseInputValueToArray(points);
    }

    return points.map(function (item) {
      if (item.lat && item.lng) return [item.lng, item.lat];
      return [item[1], item[0]];
    });
  },

  createPolygon: function (pointsArr) {
    if (!pointsArr || !this.map) return;

    var path = this.polygonPointsToPaths(pointsArr);
    if (!path.length) return;

    var polygon = new window.mapgl.Polygon(this.map, {
      coordinates: [path],
      color: 'rgba(255, 105, 0, 0.5)',
      strokeColor: '#ff6900',
      strokeWidth: 2,
    });

    this.polygons.push({ polygon: polygon, path: path });
  },

  drawPolygonFromInputs: function (classInput) {
    if (!this.map) return;

    var self = this;
    $.each(this.getInputsPolygons(classInput), function (i, item) {
      if (!item.value) return;
      self.createPolygon(self.parseInputValueToArray(item.value));
    });

    this.fitToPolygons();
  },

  fitToPolygons: function () {
    if (!this.map || !this.polygons.length) return;

    var lngs = [];
    var lats = [];
    this.polygons.forEach(function (p) {
      p.path.forEach(function (c) {
        lngs.push(c[0]);
        lats.push(c[1]);
      });
    });
    if (!lngs.length) return;

    this.map.fitBounds(
      {
        southWest: [Math.min.apply(null, lngs), Math.min.apply(null, lats)],
        northEast: [Math.max.apply(null, lngs), Math.max.apply(null, lats)],
      },
      { padding: { top: 40, right: 40, bottom: 40, left: 40 } },
    );
  },

  // The map lives in a collapsed container, so its WebGL canvas starts at 0x0.
  // Call this once the container is shown to re-measure and re-fit.
  invalidate: function () {
    if (!this.map) return;
    if (this.map.invalidateSize) this.map.invalidateSize();
    this.fitToPolygons();
  },
};
